import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b390034"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter-bwn btn line--only" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ml_5 fa fa-caret-right" }, null, -1))
const _hoisted_3 = { class: "abs dropdown-menu online" }

import { ref, computed } from 'vue'

interface I {
  value: string | number
  label: string
}

export default /*#__PURE__*/_defineComponent({
  props: ['modelValue', 'options', 'itemkey'],
  setup(__props) {

const props = __props


const hover = ref(false)

const item = computed(() => {
  return props.options.find((v: I) => v.value === props.modelValue) || {}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown cate-dropdown rel", { active: hover.value }]),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(item)))),
      _hoisted_2
    ]),
    _createVNode(_Transition, { name: "el-zoom-in-top" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (v) => {
            return (_openBlock(), _createElementBlock("div", {
              key: v.label
            }, [
              _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(v)))
            ]))
          }), 128))
        ], 512), [
          [_vShow, hover.value]
        ])
      ]),
      _: 3
    })
  ], 34))
}
}

})